export default __webpack_public_path__ + "static/media/illust_text_section4.83274829.svg";